export default {
  // 백그라운드로 넘어간 이미지 텍스트화 작업 목록.
  // 페이지를 이동해도 살아있어야 하므로 컴포넌트가 아니라 스토어에 둔다.
  jobs: [],
}
